module.exports = __webpack_public_path__ + "img/energy.99fafca2.svg";